import type { Currency } from 'types/capi/shared';

import { formatPrice } from '~/utils/prices';

type Props = {
  className?: string;
  currency: Currency;
  regular: number | null;
  sale?: number | null;
};

const Price = ({ regular, sale, currency, className = '' }: Props) => {
  if (regular && sale)
    return (
      <div className={`flex items-center ${className}`}>
        <p className="line-through">{formatPrice(regular, currency)}</p>
        <p className="text-red-alert">{formatPrice(sale, currency)}</p>
      </div>
    );

  if (regular)
    return <p className={className}>{formatPrice(regular, currency)}</p>;

  return <p className={className}>Price TBC</p>;
};

export default Price;
